import { DatabaseSnapshot } from 'angularfire2/database/interfaces';

export class EventFeature {
  static readonly PropertyKey = {
    name: 'name',
    icon: 'icon',
    order: 'order',
  };

  constructor(
    public id: string,
    public name: string | null,
    public icon: string | null,
    public order: number | null) { }

  static fromDatabaseSnapshot(snapshot: DatabaseSnapshot): EventFeature | null {
    if (!snapshot.exists() || snapshot.key === null) {
      return null;
    }

    const id = snapshot.key;

    const name = snapshot.child(EventFeature.PropertyKey.name).val();
    const icon = snapshot.child(EventFeature.PropertyKey.icon).val();
    const order = snapshot.child(EventFeature.PropertyKey.order).val();

    return new this(id, name, icon, order);
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/models/event-feature.ts